document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.startsWith('/cart')) {
    const checkoutBtn = document.querySelector('form[action="/cart"] [name="checkout"], button[name="checkout"]');

    // ⏱️ Fail-safe: Enable button after 5s even if script fails
    if (checkoutBtn) {
      checkoutBtn.disabled = true;

      setTimeout(() => {
        if (checkoutBtn.disabled) {
          console.warn("⚠️ Script may not have loaded fully. Enabling checkout.");
          checkoutBtn.disabled = false;
        }
      }, 5000);

      // ✅ Enable checkout once script is ready
      checkoutBtn.disabled = false;

      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault(); // Stop Shopify's default checkout

        // 🔹 NEW: collect order attributes (inputs like name="attributes[foo]")
        const domAttributes = {};
        document.querySelectorAll('input[name^="attributes["], textarea[name^="attributes["], select[name^="attributes["]').forEach(el => {
          const m = el.name.match(/^attributes\[(.+)\]$/);
          if (!m) return;
          const key = m[1];
          const val = (el.type === 'checkbox') ? (el.checked ? (el.value || 'true') : '') : (el.value ?? '');
          if (val !== '') domAttributes[key] = String(val);
        });

        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const items = cart.items.map(item => ({
              title: item.title,
              quantity: item.quantity,
              price: item.original_line_price / item.quantity / 100, // in dollars
              variant_id: item.variant_id,
              product_id: item.product_id
            }));

            // 🔹 NEW: merge cart-stored attributes (if any) with DOM attributes; DOM wins
            const attributes = { ...(cart.attributes || {}), ...domAttributes };

            return fetch('https://discount.gtsimulators.com/create-draft', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              // 🔹 CHANGED: include attributes in payload
              body: JSON.stringify({ items, attributes })
            });
          })
          .then(response => response.json())
          .then(data => {
            if (data.checkout_url) {
              window.location.href = data.checkout_url; // ✅ Discounted checkout
            } else {
              console.warn("⚠️ Draft server returned no checkout URL. Fallback.");
              window.location.href = "/checkout"; // fallback
            }
          })
          .catch(err => {
            console.warn("❌ Error reaching draft server. Fallback triggered.", err);
            window.location.href = "/checkout"; // fallback
          });
      });
    }
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const path = window.location.pathname;
  const isProductPage = path.includes('/products/');
  const isCollectionPage = path.includes('/collections/');
  const isVendorPage = path.includes('/a/');
  const isCartPage = path === '/cart';
  const isHomePage = path === '/';

  // Function to render the discount message
  function renderDiscountMessage(targetEl, discountValue) {
    const message = discountValue >= 3
      ? `<i class="icon-tags"></i> <strong>${discountValue}% OFF</strong> at checkout`
      : `<i class="icon-tags"></i> Get a discount at checkout`;

    targetEl.innerHTML = message;
    targetEl.style.cssText = 'background-color: #def1d5; text-wrap: nowrap; font-size: var(--SmallFontSize); border-radius: 5px; padding: 5px 8px; margin: 8px 0; font-weight: 400; color: #216e00;';
  }

  // Universal logic for ping + processing
  function processDiscountSlot(targetEl) {
    const productTags = targetEl.getAttribute('data-tags') || '';
    const match = productTags.match(/(\d+)%/);
    if (!match || isNaN(match[1]) || parseInt(match[1]) <= 0) {
      const placeholder = targetEl.querySelector('.WidgetPlaceholderLine');
      if (placeholder) placeholder.remove();
      return;
    }

    const discountValue = parseInt(match[1]);

    fetch('https://discount.gtsimulators.com/ping')
      .then(res => {
        if (!res.ok) throw new Error('Server not available');
        return res.text();
      })
      .then(() => renderDiscountMessage(targetEl, discountValue))
      .catch(err => {
        console.warn('⚠️ Discount server not available. Hiding discount message.', err);
      });

    // Always remove any lingering placeholder after 5s
    setTimeout(() => {
      const placeholder = targetEl.querySelector('.WidgetPlaceholderLine');
      if (placeholder) placeholder.remove();
    }, 5000);
  }

  // Apply to product, collection, vendor, and homepage
  if (isProductPage || isCollectionPage || isVendorPage || isHomePage || isCartPage) {
    const slots = document.querySelectorAll('.discount-msg-slot');
    slots.forEach(slot => processDiscountSlot(slot));
  }
});

setTimeout(() => {
  const placeholders = document.querySelectorAll('.discount-msg-slot .WidgetPlaceholderLine');
  placeholders.forEach(el => el.remove());
}, 5000);
